import { Button, HStack, Text } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import colors from "app/colors";
import { TrashOutlineIcon } from "modules/icons";
import { FileFragment, MessageFragment } from "gql/graphql";
import { useAuth } from "modules/providers/auth-provider";
import { useOverlay } from "modules/providers/overlay-provider";
import { MODAL_TYPE } from "modules/providers/overlay-provider/overlay-provider";

interface IProps {
  message: MessageFragment;
  file: FileFragment;
}

const MessagePopoverDeleteFileButton: React.FC<IProps> = ({
  message,
  file,
}) => {
  const { me } = useAuth();
  const { openModal } = useOverlay();

  const onDeleteFileClicked = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      if (!file.messageThreadId) return;
      openModal({
        type: MODAL_TYPE.DELETE_FILE,
        id: file.id,
        id2: file.messageThreadId,
      });
    },
    [file.id, file.messageThreadId, openModal],
  );

  if (me?.id !== message.createdUserId) {
    return null;
  }

  return (
    <Button variant="link" onClick={onDeleteFileClicked}>
      <HStack spacing={3}>
        <TrashOutlineIcon boxSize={5} fill={colors.red} />
        <Text fontSize={14} color={colors.blackSecondary}>
          Delete File
        </Text>
      </HStack>
    </Button>
  );
};

export default memo(MessagePopoverDeleteFileButton);
